(() => {
  if (window.sikVolumeTwoUpsellLoaded) return;
  window.sikVolumeTwoUpsellLoaded = true;
  const start = () => {
    const configElement = document.getElementById('SikV2UpsellConfig');
    const dialog = document.getElementById('SikV2PackOffer');
    if (!configElement || !dialog) return;
    let config;
    try { config = JSON.parse(configElement.textContent); } catch { return; }
    const ids = config.ids;
    const volumeIds = Object.values(ids).map(Number);
    const cartUrl = config.cartUrl.replace(/\/$/, '');
    const storageKey = 'sikV2PackSwap';
    const shownKey = 'sikV2PackOfferShown';
    const bypass = new WeakSet();
    const disabledControls = new Map();
    const recovery = document.querySelector('[data-sik-upgrade-recovery]');
    const status = document.querySelector('[data-sik-upgrade-status]');
    const accept = dialog.querySelector('[data-sik-offer-accept]');
    const popupError = dialog.querySelector('[data-sik-offer-error]');
    const decoder = document.createElement('textarea');
    const labels = Object.fromEntries(Object.entries(config.labels).map(([key, value]) => {
      decoder.innerHTML = value;
      return [key, decoder.value];
    }));
    let busy = false;
    let pending = null;
    let pendingForm = null;
    let offered = false;
    const readStorage = key => { try { return sessionStorage.getItem(key); } catch { return null; } };
    const writeStorage = (key, value) => { try { value ? sessionStorage.setItem(key, value) : sessionStorage.removeItem(key); return true; } catch { return false; } };
    const recoveryStorageAvailable = writeStorage(`${storageKey}Check`, '1');
    writeStorage(`${storageKey}Check`, null);
    offered = readStorage(shownKey) === '1';
    try {
      const saved = JSON.parse(readStorage(storageKey));
      if (saved && volumeIds.includes(saved.sourceId) && volumeIds.includes(saved.targetId)) pending = saved;
    } catch {}
    const text = (key, values = {}) => Object.entries(values).reduce((copy, [name, value]) => copy.split(`__${name.toUpperCase()}__`).join(String(value)).split(`{{ ${name} }}`).join(String(value)), labels[key] || '');
    const money = amount => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: config.currency || 'GBP' }).format(amount / 100);
    const countFor = id => Number(id) === ids.five ? 5 : Number(id) === ids.three ? 3 : 1;
    const savePending = value => { const saved = writeStorage(storageKey, value ? JSON.stringify(value) : null); pending = value; return saved; };
    const request = async (url, body) => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), body ? 20000 : 8000);
      try {
        const response = await fetch(url, {
          method: body ? 'POST' : 'GET', credentials: 'same-origin', signal: controller.signal,
          headers: body ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
          ...(body ? { body: JSON.stringify(body) } : { cache: 'no-store' })
        });
        if (!response.ok) {
          const error = new Error('Cart request failed');
          error.definite = response.status >= 400 && response.status < 500;
          throw error;
        }
        return await response.json();
      } finally {
        clearTimeout(timeout);
      }
    };
    const getCart = () => request(`${cartUrl}.js`);
    const getProduct = () => request(`${config.productUrl}.js`);
    const variantById = (product, id) => product.variants.find(variant => Number(variant.id) === Number(id));
    const available = variant => variant && variant.available && (!variant.quantity_rule || (variant.quantity_rule.min <= 1 && variant.quantity_rule.increment === 1));
    const volumeLines = cart => cart.items.filter(item => volumeIds.includes(Number(item.variant_id || item.id)));
    const isPlain = item => !item.selling_plan_allocation && !Object.keys(item.properties || {}).length;
    const eligible = (cart, product, sourceId) => {
      const lines = volumeLines(cart);
      const item = lines[0];
      const variant = variantById(product, sourceId);
      return lines.length === 1 && item.quantity === 1 && Number(item.variant_id || item.id) === Number(sourceId) && isPlain(item) && variant && item.final_price === variant.price ? item : null;
    };
    const cartState = (cart, plan) => {
      const lines = volumeLines(cart);
      const source = lines.filter(item => Number(item.variant_id || item.id) === plan.sourceId);
      const target = lines.filter(item => Number(item.variant_id || item.id) === plan.targetId);
      return {
        lines, source, target,
        original: lines.length === 1 && source.length === 1 && source[0].quantity === 1 && isPlain(source[0]),
        upgraded: lines.length === 1 && target.length === 1 && target[0].quantity === 1 && isPlain(target[0]),
        empty: lines.length === 0
      };
    };
    const initialisePanels = () => {
      document.querySelectorAll('[data-sik-cart-upgrade-panel]').forEach(panel => { panel.hidden = !recoveryStorageAvailable; });
      if (pending || busy) document.querySelectorAll('.Cart [name="checkout"]').forEach(button => {
        if (!disabledControls.has(button)) disabledControls.set(button, button.disabled);
        button.disabled = true;
      });
    };
    const setBusy = value => {
      busy = value;
      if (value) {
        document.querySelectorAll('.Cart button, .Cart input, .Cart select, .Cart textarea').forEach(control => {
          if (!disabledControls.has(control)) disabledControls.set(control, control.disabled);
          control.disabled = true;
        });
        status.textContent = labels.working;
      } else {
        disabledControls.forEach((wasDisabled, control) => { if (control.isConnected) control.disabled = wasDisabled; });
        disabledControls.clear();
      }
      initialisePanels();
    };
    const refresh = () => document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    const finish = (cart, upgraded) => {
      const count = countFor(pending?.targetId);
      savePending(null);
      recovery.hidden = true;
      setBusy(false);
      status.textContent = upgraded ? text('success', { count }) : labels.restored;
      refresh();
      const drawer = document.getElementById('sidebar-cart');
      if (drawer && drawer.getAttribute('aria-hidden') === 'false') drawer.querySelector('[data-action="close-drawer"]')?.focus();
      return cart;
    };
    const showRecovery = () => {
      setBusy(false);
      recovery.hidden = false;
      status.textContent = labels.uncertain;
    };
    const restore = async () => {
      let cart = await getCart();
      let state = cartState(cart, pending);
      if (state.upgraded) return finish(cart, true);
      if (state.original) return finish(cart, false);
      if (!state.empty) throw new Error('Cart changed');
      savePending({ ...pending, phase: 'restoring' });
      try { await request(`${cartUrl}/add.js`, { items: [{ id: pending.sourceId, quantity: 1 }] }); } catch {}
      cart = await getCart();
      state = cartState(cart, pending);
      if (state.original || state.upgraded) return finish(cart, state.upgraded);
      throw new Error('Restoration unconfirmed');
    };
    const recoverFailure = async error => {
      try {
        const cart = await getCart();
        const state = cartState(cart, pending);
        if (state.upgraded || (state.original && error.definite)) return finish(cart, state.upgraded);
        if (state.empty && error.definite) return await restore();
      } catch {}
      if (pending) { savePending({ ...pending, phase: 'uncertain' }); showRecovery(); }
    };
    const upgrade = async button => {
      if (busy || pending || !recoveryStorageAvailable) return;
      const panel = button.closest('[data-sik-cart-upgrade-panel]');
      const errorElement = panel.querySelector('[data-sik-cart-upgrade-error]');
      const sourceId = Number(button.dataset.sikUpgradeSource);
      const targetId = Number(button.dataset.sikCartUpgrade);
      if (![ids.single, ids.three].includes(sourceId) || ![ids.three, ids.five].includes(targetId) || countFor(targetId) <= countFor(sourceId)) return;
      errorElement.hidden = true;
      setBusy(true);
      try {
        const [cart, product] = await Promise.all([getCart(), getProduct()]);
        config.currency = cart.currency || config.currency;
        const line = eligible(cart, product, sourceId);
        const target = variantById(product, targetId);
        if (!line || !available(target)) {
          errorElement.textContent = !line ? labels.changed : labels.stock;
          errorElement.hidden = false;
          setBusy(false);
          return;
        }
        if (target.price !== Number(button.dataset.sikUpgradePrice) || line.final_price !== Number(button.dataset.sikUpgradeSourcePrice)) {
          errorElement.textContent = labels.price_changed;
          errorElement.hidden = false;
          setBusy(false);
          refresh();
          return;
        }
        if (!savePending({ sourceId, targetId, phase: 'removing' })) {
          pending = null;
          throw new Error('Recovery state unavailable');
        }
        const removed = await request(`${cartUrl}/change.js`, { id: line.key, quantity: 0 });
        if (!cartState(removed, pending).empty) throw new Error('Cart changed during replacement');
        savePending({ ...pending, phase: 'adding' });
        await request(`${cartUrl}/add.js`, { items: [{ id: targetId, quantity: 1 }] });
        const updated = await getCart();
        if (!cartState(updated, pending).upgraded) throw new Error('Upgrade unconfirmed');
        finish(updated, true);
      } catch (error) {
        if (pending) await recoverFailure(error);
        else {
          setBusy(false);
          errorElement.textContent = labels.failed;
          errorElement.hidden = false;
        }
      }
    };
    const submitOriginalForm = usePack => {
      const intent = pendingForm;
      const option = usePack ? intent?.form.querySelector(`[data-sik-purchase-variant][value="${ids.three}"]`) : null;
      if (usePack && (!option || option.disabled)) {
        popupError.textContent = labels.stock;
        popupError.hidden = false;
        accept.disabled = true;
        return;
      }
      pendingForm = null;
      dialog.close();
      if (!intent || !intent.form.isConnected) return;
      if (usePack) {
        option.checked = true;
        option.dispatchEvent(new Event('change', { bubbles: true }));
      }
      bypass.add(intent.form);
      if (typeof intent.form.requestSubmit === 'function') intent.form.requestSubmit(intent.submitter || undefined);
      else HTMLFormElement.prototype.submit.call(intent.form);
    };
    const openOffer = (form, submitter) => {
      const single = variantById(config, ids.single);
      const three = variantById(config, ids.three);
      pendingForm = { form, submitter };
      dialog.querySelector('[data-sik-offer-body]').textContent = text('modal_body', { price: money(three.price), extra: money(three.price - single.price) });
      dialog.querySelector('[data-sik-offer-saving]').textContent = text('modal_saving', { amount: money(single.price * 3 - three.price) });
      popupError.hidden = true;
      accept.disabled = false;
      accept.textContent = labels.accept;
      offered = true;
      writeStorage(shownKey, '1');
      dialog.showModal();
      dialog.querySelector('.sik-pack-offer__decline').focus();
    };
    document.addEventListener('submit', event => {
      const form = event.target;
      if ((form.matches('.Cart') || form.matches('.sik-purchase__form')) && (busy || pending)) { event.preventDefault(); if (pending && !busy) showRecovery(); return; }
      if (!form.matches('.sik-purchase__form')) return;
      if (bypass.has(form)) { bypass.delete(form); return; }
      if (offered || pendingForm || typeof dialog.showModal !== 'function') return;
      const data = new FormData(form);
      const single = variantById(config, ids.single);
      const three = variantById(config, ids.three);
      const targetOption = form.querySelector(`[data-sik-purchase-variant][value="${ids.three}"]`);
      if (Number(data.get('id')) !== ids.single || Number(data.get('quantity')) !== 1 || !single || !available(three) || !targetOption || targetOption.disabled || Number(targetOption.dataset.min || 1) > 1 || Number(targetOption.dataset.step || 1) !== 1) return;
      event.preventDefault();
      openOffer(form, event.submitter);
    }, true);
    dialog.querySelectorAll('[data-sik-offer-decline]').forEach(button => button.addEventListener('click', () => submitOriginalForm(false)));
    dialog.addEventListener('cancel', event => { event.preventDefault(); submitOriginalForm(false); });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) submitOriginalForm(false);
    });
    accept.addEventListener('click', async () => {
      if (!pendingForm) return;
      accept.disabled = true;
      accept.textContent = labels.checking;
      popupError.hidden = true;
      try {
        const product = await getProduct();
        if (!pendingForm) return;
        const three = variantById(product, ids.three);
        if (!available(three)) {
          popupError.textContent = labels.stock;
          popupError.hidden = false;
          accept.textContent = labels.accept;
          return;
        }
        const single = variantById(product, ids.single);
        if (single && (three.price !== variantById(config, ids.three).price || single.price !== variantById(config, ids.single).price)) {
          config.variants = product.variants;
          dialog.querySelector('[data-sik-offer-body]').textContent = text('modal_body', { price: money(three.price), extra: money(three.price - single.price) });
          dialog.querySelector('[data-sik-offer-saving]').textContent = text('modal_saving', { amount: money(single.price * 3 - three.price) });
          popupError.textContent = labels.price_changed;
          popupError.hidden = false;
          accept.disabled = false;
          accept.textContent = labels.accept;
          return;
        }
        submitOriginalForm(true);
      } catch {
        if (!pendingForm) return;
        popupError.textContent = labels.popup_failed;
        popupError.hidden = false;
        accept.disabled = false;
        accept.textContent = labels.accept;
      }
    });
    document.addEventListener('click', event => {
      if (busy && event.target.closest('.Cart')) { event.preventDefault(); event.stopImmediatePropagation(); return; }
      const button = event.target.closest('[data-sik-cart-upgrade]');
      if (button) { event.preventDefault(); upgrade(button); }
    }, true);
    recovery.querySelector('[data-sik-upgrade-recover]').addEventListener('click', async event => {
      if (!pending || busy) return;
      event.target.disabled = true;
      setBusy(true);
      try {
        const cart = await getCart();
        const state = cartState(cart, pending);
        if (state.original || state.upgraded) finish(cart, state.upgraded);
        else if (state.empty) await restore();
        else if (state.lines.length === 2 && state.source.length === 1 && state.target.length === 1 && state.source[0].quantity === 1 && state.target[0].quantity === 1 && state.lines.every(isPlain)) {
          const fixed = await request(`${cartUrl}/change.js`, { id: state.source[0].key, quantity: 0 });
          if (cartState(fixed, pending).upgraded) finish(fixed, true);
          else showRecovery();
        } else showRecovery();
      } catch { showRecovery(); }
      event.target.disabled = false;
    });
    initialisePanels();
    document.querySelectorAll('[data-section-type="cart"]').forEach(cart => new MutationObserver(initialisePanels).observe(cart, { childList: true, subtree: true }));
    document.addEventListener('shopify:section:load', initialisePanels);
    if (pending) {
      showRecovery();
      getCart().then(cart => {
        if (!pending || busy) return;
        const state = cartState(cart, pending);
        if (state.upgraded || (state.original && pending.phase === 'restoring')) finish(cart, state.upgraded);
      }).catch(() => {});
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
